/**
 * Som da notificação de conquista.
 *
 * O `Audio` é criado preguiçosamente (nunca durante SSR/testes) e
 * reusado entre troféus. `play()` pode ser rejeitado pela política de
 * autoplay do navegador quando não houve gesto recente do usuário —
 * nesse caso o banner aparece mudo, sem erro.
 */

const TROPHY_SOUND_URL = '/sounds/Collect_Prize.wav'

let audio: HTMLAudioElement | null = null

export function playTrophySound(): void {
  try {
    if (!audio) {
      audio = new Audio(TROPHY_SOUND_URL)
      audio.volume = 0.5
    }
    audio.currentTime = 0
    const result = audio.play()
    if (result && typeof result.catch === 'function') {
      result.catch(() => {
        // autoplay bloqueado pelo navegador — banner toca mudo
      })
    }
  } catch {
    // Audio indisponível (ambiente sem DOM) — no-op
  }
}
